import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link, useNavigate } from "react-router-dom";
import Navbar from '../../layout/Navbar';
import Preloader from '../../layout/preloader';
import Footer from '../../section-pages/footer';
import ScrollToTopBtn from '../../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import { handleRegister } from '../../api';
import { useFormik } from 'formik';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { utils, writeFile } from 'xlsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ProductionBatchForm from './ProductionBatchForm'
import MarkUp from './MarkUp'


import _ from 'lodash';


const image1 = "./img/background/5.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
`;

const defaultMarkup = {
  distributor: 0.3,
  retailer: 0.4,
};

const sampleIngredientSuggestions = [
  { name: 'Garlic', unitCost: 0.75 },
  { name: 'Lime Juice', unitCost: 1.1 },
  { name: 'Cilantro', unitCost: 0.9 },
  { name: 'Salt', unitCost: 0.5 },
  { name: 'Vinegar', unitCost: 1.3 },
];

const existingRecipes = ["Salsa Verde", "Spicy Tomato Dip"];

const unitToPound = {
  lb: 1,
  oz: 1 / 16,
  g: 0.00220462,
  kg: 2.20462,
  mg: 0.00000220462,
};


const RecipeCostingForm = () => {
  const navigate = useNavigate();
  const [recipeSummaryList, setRecipeSummaryList] = useState([]);
  const [newRow, setNewRow] = useState({
    name: '', cost: '',
    units: '',
    unitType: 'lb',
    batchType: 'Weight',
    unitValue: '',
    pounds: '',
    gals: '',
    batchWeight: '',
    tubWeight: '',
    batches: 100,
    tubWeightCount: '',
    batchWeightorCount: '',
    supplier: '',
    price: ''
  });

  const [operation, setOperation] = useState({});

  const [newRecipeRow, setNewRecipeRow] = useState({ name: '', costPerOz: '', totalOz: '', totalCost: '' });
  const [packagingCost, setPackagingCost] = useState(0.5);
  const [deliveryCost, setDeliveryCost] = useState(0);
  const [markup, setMarkup] = useState({ distributor: 0.3, retailer: 0.4 });
  const [show, setShow] = useState(false);


  // const totalCost = useMemo(() => {
  //   return recipeSummaryList.reduce((acc, r) => acc + parseFloat(r.totalCost || 0), 0) + packagingCost + deliveryCost;
  // }, [recipeSummaryList, packagingCost, deliveryCost]);



  const totalCost = useMemo(() => {
    return recipeSummaryList.reduce((acc, r) => acc + parseFloat(r.price || 0), 0);
  }, [recipeSummaryList]);

  const handleRowChange = (key, value) => {
    const updated = { ...newRow, [key]: value };
    // alert(JSON.stringify(newRow.batchWeight))

    const cost = parseFloat(updated.cost || 0);
    const units = parseFloat(updated.units || 1);
    const unitValue = parseFloat(updated.unitValue || 0);
    const unitFactor = unitToPound[updated.unitType] || 1;

    updated.pounds = (unitValue * unitFactor).toFixed(3);
    updated.costPerUnit = (units > 0 ? (cost / units).toFixed(2) : '');
    updated.costPerLb = (updated.pounds > 0 ? (cost / updated.pounds).toFixed(2) : '');

    setNewRow(updated);
  };

  const distributorPrice = totalCost * (1 + markup.distributor);
  const retailPrice = distributorPrice * (1 + markup.retailer);
  const profit = retailPrice - totalCost;

  const handleNewRecipeRowChange = (key, value) => {
    const updated = { ...newRecipeRow, [key]: value };
    updated.totalCost = (parseFloat(updated.costPerOz || 0) * parseFloat(updated.totalOz || 0)).toFixed(2);
    setNewRecipeRow(updated);
  };

  const handleAddRecipeSummary = () => {
    if (newRecipeRow.name && newRecipeRow.totalCost) {
      setRecipeSummaryList([...recipeSummaryList, newRecipeRow]);
      setNewRecipeRow({ name: '', costPerOz: '', totalOz: '', totalCost: '' });
    } else {
      alert('Please add recipe')
    }
  };

  const handleAddRow = () => {
    if (!newRow.name) return;

    const unitFactor = unitToPound[newRow.unitType] || 1;
    const pounds = (newRow.unitValue * unitFactor).toFixed(3);
    const costPerUnit = (newRow.units > 0 ? (newRow.cost / newRow.units).toFixed(2) : '');
    const costPerLb = (pounds > 0 ? (newRow.cost / pounds).toFixed(2) : '');
    const batchWeight = (parseFloat(newRow.batchWeightorCount || 0) * parseFloat(newRow.batches || 0));
    const tubWeight = Math.round(batchWeight / parseFloat(newRow.tubDevider || 1));
    const price = Math.round(parseFloat(costPerLb || 0) * batchWeight);

    const newEntry = {
      ...newRow,
      pounds,
      costPerUnit,
      costPerLb,
      batchWeight,
      tubWeight,
      price
    };

    setRecipeSummaryList([...recipeSummaryList, newEntry]);

    // Reset
    setNewRow({
      name: '',
      cost: '',
      units: 100 * 12,
      batches: '100',
      supplier: '',
      unitType: 'lb',
      unitValue: '',
      pounds: '',
      gals: '',
      tubDevider: '',
      batchType: 'Weight',
      batchWeight: '',
      tubWeightCount: '',
      batchWeightorCount: '',
      tubWeight: '',
      supplier: '',
      price: ''
    });
  };


  // const handleAddRow = () => {
  //   if (!newRow.name) return;
  //   setRecipeSummaryList([...recipeSummaryList, newRow]);
  //   setNewRow({
  //     name: '',
  //     cost: '',
  //     units: '',
  //     batches: '100',
  //     supplier: '',
  //     unitType: 'lb',
  //     unitValue: '',
  //     pounds: '',
  //     gals: '',
  //     tubDevider: '',
  //     batchWeight: '',
  //     tubWeightCount: '',
  //     batchWeightorCount: '',
  //     tubWeight: '',
  //     supplier: '',
  //     price: ''
  //   });
  // };

  useEffect(() => {
    const report = {
      ...newRow,
      batchWeight: (newRow.batchWeightorCount * 1) * (newRow.batches * 1 || 0)
    }

    setNewRow(report)

  }, [
    newRow.batches,
    newRow.batchWeightorCount
  ])

  useEffect(() => {
    const report = {
      ...newRow,
      tubWeight: Math.round(newRow.batchWeight * 1 / newRow.tubDevider * 1),
    }

    setNewRow(report)

  }, [
    newRow.batchWeight,
    newRow.tubDevider,
  ])

  useEffect(() => {
    const report = {
      ...newRow,
      price: Math.round(newRow.costPerLb * newRow.batchWeight)
    }

    setNewRow(report)

  }, [
    newRow.costPerLb,
    newRow.batchWeight
  ])

  useEffect(() => {
    const total = _.sumBy(recipeSummaryList, 'price');
    // if (!operation?.units) {
    //   alert('Update units at the header')
    // }
    if (total) {
      const report = {
        ...operation,
        totalPrice: total,
        fcInfo: (total / operation?.units),
      }
      setOperation(report)
    }

  }, [
    newRow,
    operation?.units,
    // operation?.totalPrice
  ])


  useEffect(() => {

    const report = {
      ...operation,
      units: 100 * 12,
      batchesMultiplier: 12,
      batches: 100,
      casesDevider: 6,
      cases: (100 * 12) / 6
    }
    setOperation(report)


  }, [
  ])





  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList?.add("fadeOut");
          loader.style.display = 'none';
        }, 600);
      }
    }
  }, []);
  // ... Excel import/export & useEffect remain unchanged

  return (<>
    <ProductionBatchForm
      show={show}
      setShow={setShow}
      recipeSummaryList={recipeSummaryList}
    />
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Recipe Costing Invoice</title>
    </Helmet>

    <GlobalStyles />

    <div id='mainpreloader'>
      <Preloader />
    </div>

    <div className="home dark-scheme" style={{
      // marginTop: 80
    }}>
      <header id="header-wrap">
        <Navbar
          navOptions={{
            nav_links: [
              { to: "/", label: "Home" },
              { to: "/recipes", label: "Recipes" },
              // { to: "#contact", label: "Contacts" },
              // { to: "#location", label: "Locations" }
            ],
            logo_images: {
              desktop: "./img/logo.png",
              mobile: "./img/logo-mobile.png",
            }
          }}
        />
      </header>
      <Parallax className="" bgImage={image1} strength={5}>
        <div className="de-gradient-edge-top"></div>
        <div className="de-gradient-edge-bottom"></div>


        <section className="no-bg" style={{}}>
          <div className="container mt-10">
            <h3 className="text-xl font-semibold mb-4">Client Information</h3>
            <div className="container mt-10">
              <table className="w-full text-center border border-gray-300 mb-6">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">Client</th>
                    <th className="p-2 border">Address</th>
                    <th className="p-2 border">Invoice # </th>
                    <th className="p-2 border">Date:</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Existing data rows */}
                  <tr className="bg-yellow-50">
                    <td>
                      <input
                        // defaultValue={'????'}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            client: e.target.value,
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        // defaultValue={12}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            address: e.target.value,
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        // defaultValue={12}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            date: e.target.value,
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        defaultValue={12}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            date: e.target.value,
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded"
                        type="date"
                      />
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>


        <section className="no-bg" style={{
          marginTop: -40
        }}>
          <div className="container mt-10">
            <h3 className="text-xl font-semibold mb-4">Costing Table</h3>
            <div className="container mt-10">


              <table className="w-full text-center border border-gray-300 mb-6">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">Batches</th>
                    <th className="p-2 border">Batches Multiplier (BM)</th>
                    <th className="p-2 border">Units: (batches * BM)</th>
                    <th className="p-2 border">Cases Devider:</th>
                    <th className="p-2 border">Cases: (Units/Cases Devider)</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Existing data rows */}
                  <tr className="bg-yellow-50">
                    <td>
                      <input value={newRow.batches}
                        defaultValue={100} onChange={(e) => {
                          handleRowChange('batches', e.target.value)
                        }} className="w-full p-1 border rounded" type="number" />

                    </td>
                    <td>
                      <input
                        // value={operation.batchesMultiplier}
                        defaultValue={12}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            batchesMultiplier: e.target.value,
                            units: e.target.value * newRow.batches
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded"
                        type="number"
                      />
                    </td>
                    <td>
                      {operation.units}
                      {/* <input value={newRow.batches} defaultValue={100} onChange={(e) => handleRowChange('batches', e.target.value)} className="w-full p-1 border rounded" type="number" /> */}
                    </td>
                    <td>
                      <input
                        // value={newRow.casesDevider}
                        defaultValue={6}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            casesDevider: e.target.value,
                            cases: Math.round(operation?.units / e.target.value)
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded" type="number" />

                    </td>
                    <td>
                      {Math.round(operation.cases)}
                    </td>
                  </tr>
                </tbody>
              </table>


              <div style={{
                overflowX: 'auto',
                paddingTop: 20,
                paddingBottom: 20
              }}>



                <table className="w-full text-left border border-gray-300 mb-6">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 border">Ingredient</th>
                      <th className="p-2 border">Cost</th>
                      <th className="p-2 border">Units</th>
                      <th className="p-2 border" style={{
                        backgroundColor: 'green'
                      }}>Metric</th>
                      <th className="p-2 border" style={{
                        backgroundColor: 'green'
                      }}>Weight</th>
                      <th className="p-2 border" >Pounds</th>
                      {/* <th className="p-2 border">Gals</th> */}
                      <th className="p-2 border">Cost/Unit</th>
                      <th className="p-2 border">Cost/Lb</th>
                      <th className="p-2 border">
                        Batch or Quantity
                      </th>
                      <th className="p-2 border">
                        Batch Type
                      </th>
                      <th className="p-2 border">Batch Weight</th>
                      <th className="p-2 border">
                        Tub Weight Devider
                      </th>
                      <th className="p-2 border">
                        Tub Weight
                      </th>
                      <th className="p-2 border">Price</th>
                      <th className="p-2 border">Supplier</th>
                      <th className="p-2 border">Add</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Existing data rows */}
                    <tr className="bg-yellow-50">
                      <td className="p-2 border"><input value={newRow.name} onChange={(e) => handleRowChange('name', e.target.value)} className="w-full p-1 border rounded" /></td>
                      <td className="p-2 border"><input value={newRow.cost} onChange={(e) => handleRowChange('cost', e.target.value)} className="w-full p-1 border rounded" type="number" /></td>
                      <td className="p-2 border"><input value={newRow.units} onChange={(e) => handleRowChange('units', e.target.value)} className="w-full p-1 border rounded" type="number" /></td>
                      <td className="p-2 border">
                        <select value={newRow.unitType} onChange={(e) => handleRowChange('unitType', e.target.value)} className="w-full p-1 border rounded">
                          <option value="lb">lb</option>
                          <option value="oz">oz</option>
                          <option value="g">g</option>
                          <option value="kg">kg</option>
                          <option value="mg">mg</option>
                        </select>
                      </td>
                      <td className="p-2 border"><input value={newRow.unitValue} onChange={(e) => handleRowChange('unitValue', e.target.value)} className="w-full p-1 border rounded" type="number" /></td>
                      <td className="p-2 border">{newRow.pounds}</td>
                      {/* <td className="p-2 border"><input value={newRow.gals} onChange={(e) => handleRowChange('gals', e.target.value)} className="w-full p-1 border rounded" type="number" /></td> */}
                      <td className="p-2 border">${newRow.costPerUnit || '0.00'}</td>
                      <td className="p-2 border">${newRow.costPerLb || '0.00'}</td>
                      {/* <td className="p-2 border"><input value={newRow.batchWeight} onChange={(e) => handleRowChange('batchWeight', e.target.value)} className="w-full p-1 border rounded" type="number" /></td> */}
                      <td className="p-2 border"><input value={newRow.batchWeightorCount} onChange={(e) => handleRowChange('batchWeightorCount', e.target.value)} className="w-full p-1 border rounded" type="number" /></td>
                      <td className="p-2 border">    <select value={newRow.batchType} onChange={(e) => handleRowChange('batchType', e.target.value)} className="w-full p-1 border rounded">
                        <option value="Weight">Weight</option>
                        <option value="Quantity">Quantity</option>
                      </select></td>
                      <td className="p-2 border">
                        {newRow.batchWeight}
                      </td>
                      <td className="p-2 border">
                        <input value={newRow.tubDevider} onChange={(e) => handleRowChange('tubDevider', e.target.value)} className="w-full p-1 border rounded" type="number" />
                      </td>
                      <td className="p-2 border">
                        ${newRow?.tubWeight}
                        {/* <input value={newRow.price} onChange={(e) => handleRowChange('price', e.target.value)} className="w-full p-1 border rounded" type="text" /> */}
                      </td>
                      <td className="p-2 border text-center">
                        ${newRow?.price || ''}
                        {/* <input value={newRow.supplier} onChange={(e) => handleRowChange('supplier', e.target.value)} className="w-full p-1 border rounded" type="text" /> */}
                      </td>
                      <td className="p-2 border text-center">
                        <input value={newRow.supplier} onChange={(e) => handleRowChange('supplier', e.target.value)} className="w-full p-1 border rounded" type="text" />
                      </td>
                      <td className="p-2 border text-center">
                        <button onClick={handleAddRow} className="bg-green-500 text-white px-2 py-1 rounded">+</button>
                      </td>
                    </tr>
                    {recipeSummaryList.map((row, index) => (
                      <tr key={index} className="bg-white" style={{
                        color: 'black'
                      }}>
                        <td className="p-2 border">{row.name}</td>
                        <td className="p-2 border">${row.cost}</td>
                        <td className="p-2 border">{row.units}</td>
                        <td className="p-2 border">{row.unitType}</td>
                        <td className="p-2 border">{row.unitValue}</td>
                        <td className="p-2 border">{row.pounds}</td>
                        <td className="p-2 border">${row.costPerUnit}</td>
                        <td className="p-2 border">${row.costPerLb}</td>
                        <td className="p-2 border">{row.batchWeightorCount}</td>
                        <td className="p-2 border">{row.batchType || 'Weight'}</td>
                        <td className="p-2 border">{row.batchWeight}</td>
                        <td className="p-2 border">{row.tubDevider}</td>
                        <td className="p-2 border">{row.tubWeight}</td>
                        <td className="p-2 border">${row.price}</td>
                        <td className="p-2 border">{row.supplier}</td>
                        <td className="p-2 border text-center">—</td>
                      </tr>
                    ))}

                    {recipeSummaryList?.[0] && <tr className="bg-white">
                      <td className="p-2 border">{
                        //'row.name'
                      }</td>
                      <td className="p-2 border">{
                        //'row.cost'
                      }</td>
                      <td className="p-2 border">{
                        // row.units
                      }</td>
                      <td className="p-2 border">{
                        // row.unitType
                      }</td>
                      <td className="p-2 border">{
                        // row.unitValue
                      }</td>
                      <td className="p-2 border">{
                        // row.pounds
                      }</td>
                      <td className="p-2 border">{
                        // row.costPerUnit
                      }</td>
                      <td className="p-2 border">{
                        // row.costPerLb
                      }</td>
                      <td className="p-2 border">{
                        // row.batchType
                      }</td>
                      <td className="p-2 border">{
                        // row.batchWeightorCount
                      }</td>
                      <td className="p-2 border">{
                        // row.tubDevider
                      }</td>
                      <td className="p-2 border">{
                        // row.batchWeightorCount
                      }</td>
                      <td className="p-2 border">{
                        // row.tubDevider
                      }</td>
                      <td className="p-2 border">${
                        operation?.totalPrice
                      }</td>
                      <td className="p-2 border">{
                        // row.supplier
                      }</td>
                      <td className="p-2 border text-center">—</td>
                    </tr>}



                  </tbody>
                </table>
              </div>


              <table className="table table-bordered w-full mt-4">
                <thead>
                  <tr>
                    <th>FC ( total price / Units)</th>
                    <th>PC</th>
                    <th>Hrs</th>
                    <th>FC+PC</th>
                    <th>MC (Input) </th>
                    <th>FC+PC</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>${operation?.fcInfo?.toFixed(2)}</td>
                    <td>
                      <input
                        // value={newRow.casesDevider}
                        defaultValue={6}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            pcInfo: e.target.value,
                            FCplusPCInfo: Math.round(totalCost.toFixed(2) + e.target.value)
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded" type="number" />
                    </td>
                    <td>
                      <input
                        // value={newRow.casesDevider}
                        defaultValue={6}
                        onChange={(e) => {
                          // handleRowChange('batches', e.target.value) 
                          const report = {
                            ...operation,
                            hrsInfo: e.target.value,
                            // cases: Math.round(operation?.units / e.target.value)
                          }
                          setOperation(report)
                        }}
                        className="w-full p-1 border rounded" type="number" />
                    </td>
                    <td>
                      {operation?.FCplusPCInfo}
                    </td>
                    <td> <input
                      // value={newRow.casesDevider}
                      defaultValue={6}
                      onChange={(e) => {
                        // handleRowChange('batches', e.target.value) 
                        const report = {
                          ...operation,
                          mcInfo: e.target.value,
                          totalCostInfo: Math.round(e.target.value + operation?.FCplusPCInfo),

                        }
                        setOperation(report)
                      }}
                      className="w-full p-1 border rounded" type="number" /></td>
                    <td>${operation?.FCplusPCInfo?.toFixed(2)}</td>
                    <td>${operation?.totalCostInfo?.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>

              <MarkUp totalCostInfo={operation?.totalCostInfo} />


              {/* <h3 className="text-xl font-semibold mb-4">Recipe Costing Table</h3>
              <table className="w-[900px] mt-5 border-spacing-y-4 border-separate">
                <tbody>
                  <tr >
                    <td className="font-semibold pr-4">Packaging Cost</td>
                    <td className="w-full">
                      <input
                        type="number"
                        value={packagingCost}
                        onChange={(e) => setPackagingCost(parseFloat(e.target.value))}
                        className="w-full border p-2 rounded"
                        style={{
                          margin: 7
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold pr-4">Delivery Cost</td>
                    <td className="w-full">
                      <input
                        type="number"
                        value={deliveryCost}
                        onChange={(e) => setDeliveryCost(parseFloat(e.target.value))}
                        className="w-full border p-2 rounded"
                        style={{
                          margin: 7
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold pr-4">Distributor Markup (%)</td>
                    <td className="w-full">
                      <input
                        type="number"
                        value={markup.distributor * 100}
                        onChange={(e) =>
                          setMarkup({ ...markup, distributor: parseFloat(e.target.value) / 100 })
                        }
                        className="w-full border p-2 rounded"
                        style={{
                          margin: 7
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold pr-4">Retailer Markup (%)</td>
                    <td className="w-full">
                      <input
                        type="number"
                        value={markup.retailer * 100}
                        onChange={(e) =>
                          setMarkup({ ...markup, retailer: parseFloat(e.target.value) / 100 })
                        }
                        className="w-full border p-2 rounded"
                        style={{
                          margin: 7
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table> */}


              {/* <div className="border-t pt-4">
                <h3 className="text-xl font-semibold mb-2">Invoice Summary</h3>
                <p><strong>Total Cost:</strong> ${totalCost.toFixed(2)}</p>
                <p><strong>Distributor Price:</strong> ${distributorPrice.toFixed(2)}</p>
                <p><strong>Retail Price:</strong> ${retailPrice.toFixed(2)}</p>
                <p><strong>Estimated Profit:</strong> ${profit.toFixed(2)}</p>
              </div> */}
            </div>


            <Modal.Footer>
              <Button variant="secondary" onClick={() => {
                setShow(false)
              }}>
                Close
              </Button>
              <Button
                onClick={() => {
                  setShow(true)
                }}
                variant="primary">
                Save Changes
              </Button>
            </Modal.Footer>

          </div>
        </section>
      </Parallax>

      <Footer />
    </div >
    <ScrollToTopBtn />
  </>);
};

export default RecipeCostingForm;
